import 'reakit/styled';
import { palette, theme } from 'styled-tools';
import 'styled-selector';
import selector from '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import { darken } from 'polished';
import _defaultPalette from '../default/palette.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import StyledIcon from '../Icon/styled.js';
import _Link from 'reakit/Link';

var defaultPalette = _defaultPalette({});

var Link = styled(_Link).withConfig({
  displayName: "styled__Link",
  componentId: "q8ut33-0"
})(["color:", ";fill:", ";cursor:pointer;text-decoration:underline;text-decoration-skip:ink edges;&:hover{color:", ";fill:", ";}& ", "{top:0.15em;}&{", ";}"], palette('primary'), palette('primary'), function (props) {
  return darken(0.5, palette('primary', 0, defaultPalette.primary)(props));
}, function (props) {
  return darken(0.5, palette('primary', 0, defaultPalette.primary)(props));
}, selector(StyledIcon), theme('fannypack.Link.base'));
export default Link;
export { Link };